
import _ from 'lodash';
import $uri from 'uri-tag';
import moment from 'moment';
import { formatDateTimeRange } from '../../util/formatting.js';
import { mapToElements } from '../../util/functional.js';
import Imm from 'immutable';

import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import cx from 'classnames';
import * as ReactRedux from 'react-redux';

import inject from '../../util/di/inject.js';
import { Link } from 'react-router-dom';

import Slider from 'react-slick';
import Text from '../../components/Text.js';

import * as FavoriteService from '../../services/model/FavoriteService.js';
import { convertPath, getFallbackImage, imageUrl } from '../../services/model/ImageService.js';

import SocialMediaService from '../../services/SocialMediaService.js';
import api from '../../services/CpgApi.js';
import Event from '../../models/Event.js';

import EventSchema from './EventSchema.js';


const sliderConfig = {
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    arrows: false,
    draggable: false,
    fade: true,
    speed: 1000,
};

@ReactRedux.connect(
    state => ({
        myList: state.app.authUser.eventFavorites,
        auth: state.getIn(['session', 'auth']),
    }),
    dispatch => ({
        dispatch,
    }),
    (stateProps, dispatchProps, otherProps) => ({
        ...stateProps,
        ...dispatchProps,
        ...otherProps,
        toggleFavorite: event => {
            return FavoriteService.toggleFavorite({
                auth: stateProps.auth,
                dispatch: dispatchProps.dispatch,
                myList: stateProps.myList,
                event,
            });
        },
    }),
)
@inject({
    responsive: 'cpg.responsive',
    sites: 'cpg.sites',
})
export default class EventAdvancedDetail extends React.PureComponent {
    static propTypes = {
        event: PropTypes.instanceOf(Event).isRequired,
    };
    
    state = {
        descriptionActive: false,
    };
    
    socialMediaService = new SocialMediaService();
    
    getBaseUrl() {
        return this.props.sites.getBaseUrl();
    }
    
    goto = location => {
        window.open(location, '_blank');
    };
    
    load(prevProps, prevState) {
        const { auth, myList } = this.props;
        
        if (auth) {
            if (myList.meta.status === 'invalid') {
                this.props.dispatch(api.eventFavorites.list());
            }
        }
    }
    
    genTwitterLink(event) {
        return `https://twitter.com/intent/tweet?url=${this.getBaseUrl()}/event/${encodeURIComponent(event.get('slug'))}`
            + `&text=${encodeURIComponent(event.get('name'))}`;
    }
    
    genFacebookLink(event) {
        const facebookId = '213397552516471';
        return `https://facebook.com/dialog/feed?app_id=${facebookId}`
            + `&display=popup&link=${this.getBaseUrl()}/event/${encodeURIComponent(event.get('slug'))}`
            + `&name=${encodeURIComponent(event.get('name'))}`
            + `&description=${encodeURIComponent(event.get('description'))}`;
    }
    
    genWhatsAppLink(event) {
        return `whatsapp://send?text=${encodeURIComponent(event.get('name'))}`
            + ` - ${this.getBaseUrl()}/event/${encodeURIComponent(event.get('slug'))}`;
    }
    
    genEmailLink(event) {
        return `mailto:?subject=${encodeURIComponent(event.get('name'))}`
            + `&body=${this.getBaseUrl()}/event/${encodeURIComponent(event.get('slug'))}`
            + `%0A%0A${encodeURIComponent(event.get('description'))}`;
    }
    
    genGoogleMapsUrl(event) {
        const queryItems = [
            event.location.address,
            event.location.postcode,
            event.location.city,
        ];
        
        const query = queryItems
            .filter(item => item != null && item !== '')
            .join(',');
        
        return $uri`https://maps.google.com/maps?q=${query}`;
    }
    
    componentDidMount() {
        this.load();
    }
    
    componentDidUpdate(prevProps, prevState) {
        this.load(prevProps, prevState);
        
        if (this.props.event.id !== prevProps.event.id) {
            // Reset state when we switch events
            this.setState({ descriptionActive: false });
        }
    }
    
    render() {
        const { event, myList, update, auth } = this.props;
        
        // FIXME: event.images is sometimes an array at the moment, should be an Image collection
        const imagesArray = Array.isArray(event.images) ? event.images : event.images.toArray();
        
        const images = imagesArray.length !== 0
            ? imagesArray.map((image, index) => (
                <div key={index}
                    className="background-image-item lazyload"
                    data-bgset={
                    `${convertPath(image.path)}&w=600&h=270&fit=crop-center [(max-width: 600px)] | ${convertPath(image.path)}&w=768&h=416&fit=crop-center [(max-width: 992px)] | ${convertPath(image.path)}&w=1220&h=536&fit=crop-center` 
                    }
                />
            ))
            : [
                <div key="placeholder" className="background-image-item"
                     style={{ backgroundImage: `url(${getFallbackImage()}&w=1220&h=536&fit=crop&fit=crop-center)` }}
                />
            ];
        
        return (
            <div className="item-more-details">
                <Helmet>
                    <title>{event.name}</title>
                    <meta name="description" content={event.summary}/>
                    
                    <meta property="og:type" content="website"/>
                    <meta property="og:url" content={$uri`${$uri.raw(this.getBaseUrl())}/event/${encodeURIComponent(event.get('slug'))}`}/>
                    <meta property="og:title" content={event.name}/>
                    <meta property="og:description" content={event.description.replace(/\s+/g, ' ')}/>
                    <meta property="og:image" content={
                        imagesArray.length === 0
                            ? ''
                            : imageUrl + $uri`/backend/image?src=${imagesArray[0].path}&w=800&h=500&fit=crop&fit=crop-center`
                    }/>
                    <meta property="og:image:width" content="800"/>
                    <meta property="og:image:height" content="500"/>
                </Helmet>
                
                <div className="item-details-slider-wrapper">
                    {images && images.length > 0 &&
                        <Slider {...sliderConfig}
                            className="background-image-slider col-sm-offset-0 col-md-offset-2 col-lg-offset-4 col-xl-offset-4"
                        >
                            {images}
                        </Slider>
                    }
                </div>
                <div className="row item-details-inner-wrapper">
                    {!this.state.descriptionActive
                        ?
                        <React.Fragment>
                            <div className="col-xs-12 col-ms-12 col-sm-10 col-lg-7 col-xl-6 item-details-content-wrapper vertical-align-xs">
                                <div className="item-details-content clearfix">
                                    {/*<a className='btn btn-default btn-sm margin20B' onClick={() => history.push('/')}>
                                            <span className="icon icon-arrow-left" aria-hidden="true" aria-label="Arrow left icon"></span>
                                            Back to home
                                    </a>*/}
                                    <h1 title={event.get('name')}>
                                        {_.truncate(event.get('name'), {
                                            'length': 72
                                        })}
                                    </h1>
                                    <p>
                                        <strong className="detail-label">When:</strong>
                                        {formatDateTimeRange(
                                            moment(event.get('start_date')),
                                            event.get('end_date') && moment(event.get('end_date')),
                                            {
                                                recurring_label: event.recurring_label,
                                                recurring_until: moment(event.recurring_until),
                                                recurring_interval: event.recurring_interval
                                            }
                                        )}
                                    </p>
                                    <p>
                                        <strong className="detail-label">Where:</strong> 
                                        <Link className="item-venue-link" to={`/venues/${event.get('location').slug}`}>
                                            <span>{_.truncate(event.get('location').name, { length: 40 })}</span>
                                        </Link>
                                        {event.get('location') && event.get('location').address && event.get('location').postcode && event.get('location').city &&
                                            <span className="item-maps-link">
                                                <a target="_blank" href={this.genGoogleMapsUrl(event)}>
                                                    (Open in Google Maps)
                                                </a>
                                            </span>
                                        }
                                    </p>
                                    <p>
                                        <strong className="detail-label">Details:</strong>
                                        {' '}
                                        <Text
                                            maxLength={250}
                                            newlines="merge"
                                            moreAction={
                                                <span>
                                                    <br className="visible-xs"/>
                                                    <a onClick={() => { this.setState({ descriptionActive: true }); window.scrollTo(0, 0); }}>
                                                        (Read more)
                                                    </a>
                                                </span>
                                            }
                                        >
                                            {event.description}
                                        </Text>
                                    </p>
                                    {event.price && event.get('price') !== "" &&
                                        <p>
                                            <strong className="detail-label">Price:</strong> {event.get('price')}
                                        </p>
                                    }
                                    <div className="margin20T action-buttons btn-group hidden-xs hidden-sm" role="group" aria-label="Action buttons">
                                        {event.get('ticket_link') && event.get('ticket_link') !== "" &&
                                            <div className="btn btn-primary" onClick={() => this.goto(event.get('ticket_link'))} role="button">
                                                <span className="icon icon-control-play" aria-hidden="true" aria-label="Buy tickets icon"/>
                                                Buy tickets
                                            </div>
                                        }
                                        {event.get('website') && event.get('website') !== '' &&
                                            <div className="btn btn-primary"
                                               onClick={() => this.goto(event.get('website'))}
                                               role="button">
                                                <span className="icon icon-link"
                                                      aria-hidden="true"
                                                      aria-label="Website icon"
                                                />
                                                Website
                                            </div>
                                        }
                                        {event.get('facebook_link') && event.get('facebook_link') !== "" &&
                                            <div className="btn btn-primary"
                                                 onClick={() => this.goto(event.get('facebook_link'))}
                                                 role="button">
                                                <span className="icon icon-social-facebook" aria-hidden="true" aria-label="Facebook icon"/>
                                                Facebook
                                            </div>
                                        }
                                        <a className="btn btn-default"
                                            href={this.socialMediaService.genGoogleCalendarLink(event)}
                                            target="_blank"
                                            rel="nofollow"
                                        >
                                            <span className="icon icon-social-google" aria-hidden="true"
                                                aria-label="Add to Google Calendar"
                                                aria-label="Add to list icon"
                                            />
                                            {' '}
                                            Add to Google Calendar
                                        </a>
                                        {!auth &&
                                            <a className="btn btn-default"
                                                role="button"
                                                onClick={() => {
                                                    this.props.toggleFavorite(event);
                                                }}
                                            >
                                                <span>
                                                    <span className="icon icon-plus" aria-hidden="true"
                                                        aria-label="Add to list icon"
                                                    />
                                                    {' '}
                                                    Add to My List
                                                </span>
                                            </a>
                                        }
                                        {auth && myList.meta.status === 'ready' &&
                                            <a className="btn btn-default"
                                                role="button"
                                                onClick={() => {
                                                    this.props.toggleFavorite(event);
                                                }}
                                            >
                                                {myList.has(event.slug)
                                                    ?
                                                        <span>
                                                            <span className="icon icon-minus" aria-hidden="true"
                                                                aria-label="Remove from list icon"
                                                            />
                                                            {' '}
                                                            Remove from My List
                                                        </span>
                                                    :
                                                        <span>
                                                            <span className="icon icon-plus" aria-hidden="true"
                                                                aria-label="Add to list icon"
                                                            />
                                                            {' '}
                                                            Add to My List
                                                        </span>
                                                }
                                            </a>
                                        }
                                    </div>
                                    
                                    <div className="margin20T action-buttons visible-xs visible-sm" role="group" aria-label="Action buttons">
                                        {event.get('website') && event.get('website') !== '' &&
                                            <a href="#" className="btn btn-outline btn-primary btn-block"
                                               onClick={() => this.goto(event.get('website'))} role="button">
                                                <span className="icon icon-link" aria-hidden="true"
                                                      aria-label="Website icon"/>
                                                Website
                                            </a>
                                        }
                                        {event.get('facebook_link') && event.get('facebook_link') !== "" &&
                                            <a className="btn btn-outline btn-primary btn-block margin20T"
                                                onClick={() => this.goto(event.get('facebook_link'))}
                                                role="button">
                                                <span className="icon icon-social-facebook" aria-hidden="true" aria-label="Facebook icon" />
                                                Facebook
                                            </a>
                                        }
                                        <a className="btn btn-outline btn-primary btn-block"
                                            href={this.socialMediaService.genGoogleCalendarLink(event)}
                                            target="_blank"
                                            rel="nofollow"
                                        >
                                            <span className="icon icon-social-google" aria-hidden="true"
                                                aria-label="Add to Google Calendar"
                                                aria-label="Add to list icon"
                                            />
                                            {' '}
                                            Add to Google Calendar
                                        </a>
                                        {event.get('ticket_link') && event.get('ticket_link') !== "" &&
                                            <a href="#" className="btn btn-outline btn-primary btn-block margin20T"
                                               onClick={() => this.goto(event.get('ticket_link'))} role="button">
                                                <span className="icon icon-control-play" aria-hidden="true"
                                                      aria-label="Buy tickets icon"/>
                                                Buy tickets
                                            </a>
                                        }
                                        
                                        {!auth &&
                                            <a
                                                role="button"
                                                className="btn btn-primary btn-block margin20T"
                                                onClick={() => {
                                                    this.props.toggleFavorite(event);
                                                }}
                                            >
                                                <span className="icon icon-plus" aria-hidden="true"
                                                    aria-label="Add to list icon"
                                                />
                                                {' '}
                                                Add to My List
                                            </a>
                                        }
                                        {auth && myList.meta.status === 'ready' &&
                                            <a
                                                role="button"
                                                className="btn btn-primary btn-block margin20T"
                                                onClick={evt => {
                                                    this.props.toggleFavorite(event);
                                                }}
                                            >
                                                {myList.has(event.slug)
                                                    ?
                                                        <span>
                                                            <span className="icon icon-minus" aria-hidden="true"
                                                                aria-label="Remove from list icon"
                                                            />
                                                            {' '}
                                                            Remove from My List
                                                        </span>
                                                    :
                                                        <span>
                                                            <span className="icon icon-plus" aria-hidden="true"
                                                                aria-label="Add to list icon"
                                                            />
                                                            {' '}
                                                            Add to My List
                                                        </span>
                                                }
                                            </a>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="share-buttons-wrapper">
                                <h3 className="title">
                                  Share<span className="visible-lg-inline visible-md-inline visible-xs-inline"> this event</span>
                                </h3>
                                {' '}
                                <a target="_blank" rel="noopener noreferrer" className="share share-twitter"
                                    href={this.genTwitterLink(event)}
                                >
                                    <svg className="svg img-responsive" width="30" height="30" enableBackground="new 0 0 32 32" version="1.1" viewBox="0 0 32 32">
                                        <title>Share this event on twitter</title>
                                        <g id="icon-twitter">
                                            <g>
                                                <path className="circle" d="M16,0C7.163,0,0,7.163,0,16c0,8.836,7.163,16,16,16s16-7.164,16-16C32,7.163,24.837,0,16,0z" fill="#000"/>
                                            </g>
                                            <path className="logo" d="M18.226,8.886c-1.59,0.579-2.595,2.071-2.481,3.704l0.038,0.63l-0.636-0.077   c-2.315-0.296-4.338-1.299-6.056-2.984l-0.84-0.836L8.036,9.94c-0.458,1.376-0.165,2.83,0.789,3.808   c0.509,0.54,0.394,0.617-0.483,0.296c-0.305-0.103-0.573-0.18-0.598-0.141c-0.089,0.09,0.216,1.26,0.458,1.724   c0.331,0.644,1.005,1.273,1.743,1.647l0.624,0.296L9.83,17.581c-0.712,0-0.738,0.013-0.661,0.284   c0.254,0.836,1.259,1.724,2.379,2.11l0.789,0.27l-0.687,0.412c-1.018,0.593-2.214,0.927-3.41,0.951   c-0.573,0.013-1.044,0.064-1.044,0.103c0,0.128,1.553,0.848,2.455,1.132c2.71,0.836,5.929,0.475,8.346-0.952   c1.718-1.016,3.435-3.036,4.237-4.992c0.433-1.041,0.865-2.945,0.865-3.858c0-0.592,0.038-0.669,0.75-1.376   c0.42-0.412,0.814-0.862,0.891-0.99c0.128-0.245,0.114-0.245-0.534-0.026c-1.081,0.386-1.234,0.335-0.699-0.244   c0.394-0.412,0.865-1.158,0.865-1.376c0-0.038-0.191,0.026-0.407,0.141c-0.229,0.129-0.738,0.322-1.12,0.437l-0.687,0.219   L21.535,9.4c-0.344-0.231-0.826-0.489-1.081-0.566C19.804,8.654,18.812,8.68,18.226,8.886z" fill="transparent"/>
                                        </g>
                                    </svg>
                                </a>                                        
                                
                                <a target="_blank" rel="noopener noreferrer" className="share share-facebook"
                                    href={this.genFacebookLink(event)}
                                >
                                    <svg className="svg img-responsive" width="30" height="30" enableBackground="new 0 0 32 32" version="1.1" viewBox="0 0 32 32">
                                        <title>Share this event on Facebook</title>
                                        <g id="icon-facebook">
                                            <g>
                                                <path className="circle" d="M16,0C7.163,0,0,7.163,0,16c0,8.836,7.163,16,16,16s16-7.164,16-16C32,7.163,24.837,0,16,0z" fill="#000"/>
                                            </g>
                                            <path className="logo" d="M13.69,24.903h3.679v-8.904h2.454l0.325-3.068h-2.779l0.004-1.536c0-0.8,0.076-1.229,1.224-1.229h1.534   V7.097h-2.455c-2.949,0-3.986,1.489-3.986,3.992v1.842h-1.838v3.069h1.838V24.903z" fill="transparent"/>
                                        </g>
                                    </svg>
                                </a>
                                
                                {this.props.responsive.isTouchEnabled() &&
                                    <a href={this.genWhatsAppLink(event)} className="share share-whatsapp">
                                        <svg className="svg img-responsive" width="30" height="30" enableBackground="new 0 0 32 32" version="1.1" viewBox="0 0 32 32">
                                            <title>Share this event on Whatsapp</title>
                                            <g id="icon-whatsapp">
                                                <g>
                                                    <path className="circle" width="30" height="30" d="M16,0C7.163,0,0,7.163,0,16c0,8.836,7.163,16,16,16s16-7.164,16-16C32,7.163,24.837,0,16,0z" fill="#000"/>
                                                </g>
                                                <g fill="none" fillRule="evenodd" id="black" stroke="none" strokeWidth="1">
                                                    <g transform="translate(6.000000, 6.000000), scale(0.6)">
                                                        <path fill="#fff" className="logo" d="M17.0712615,33.2210462 C14.2108308,33.2210462 11.5235692,32.4899692 9.1856,31.2068923 L0.153846154,34.0769231 L3.09809231,25.3918769 C1.61304615,22.9523692 0.757538462,20.0915692 0.757538462,17.0336 C0.757538462,8.09341538 8.06129231,0.846153846 17.0716308,0.846153846 C26.0808615,0.846153846 33.3846154,8.09341538 33.3846154,17.0336 C33.3846154,25.9737846 26.0812308,33.2210462 17.0712615,33.2210462 Z M17.0712615,3.42412308 C9.50793846,3.42412308 3.35581538,9.52935385 3.35581538,17.0336 C3.35581538,20.0114462 4.32652308,22.7692308 5.96812308,25.0130462 L4.25489231,30.0670769 L9.52529231,28.3918769 C11.6912,29.8137846 14.2854154,30.6430769 17.0712615,30.6430769 C24.6334769,30.6430769 30.7867077,24.5382154 30.7867077,17.0339692 C30.7867077,9.52972308 24.6334769,3.42412308 17.0712615,3.42412308 L17.0712615,3.42412308 Z M25.3088,20.7617231 C25.2083692,20.5966769 24.9417846,20.4969846 24.5426462,20.2987077 C24.1424,20.1004308 22.1758769,19.1400615 21.8099692,19.0082462 C21.4429538,18.8760615 21.176,18.8092308 20.9097846,19.2065231 C20.6435692,19.6038154 19.8770462,20.4969846 19.6433231,20.7617231 C19.4099692,21.0268308 19.1769846,21.0600615 18.7771077,20.8614154 C18.3776,20.6631385 17.0889846,20.2440615 15.5611077,18.8923077 C14.3725538,17.8407385 13.5698462,16.5425231 13.3368615,16.1448615 C13.1035077,15.7479385 13.3121231,15.5334154 13.5122462,15.3358769 C13.6920615,15.1579077 13.9121231,14.8724923 14.1122462,14.6409846 C14.3123692,14.4091077 14.3788308,14.2440615 14.5117538,13.9789538 C14.6454154,13.7142154 14.5785846,13.4827077 14.4785231,13.2836923 C14.3784615,13.0854154 13.5783385,11.1329231 13.2452923,10.3383385 C12.9122462,9.54449231 12.5795692,9.67667692 12.3458462,9.67667692 C12.1124923,9.67667692 11.8459077,9.64344615 11.5793231,9.64344615 C11.3127385,9.64344615 10.8792615,9.74276923 10.5126154,10.1396923 C10.1463385,10.5369846 9.1136,11.4969846 9.1136,13.4491077 C9.1136,15.4016 10.5458462,17.288 10.7463385,17.5523692 C10.9460923,17.8167385 13.5118769,21.9536 17.5767385,23.5424 C21.6430769,25.1308308 21.6430769,24.6009846 22.3763692,24.5348923 C23.1085538,24.4688 24.7412923,23.5752615 25.0754462,22.6488615 C25.4081231,21.7217231 25.4081231,20.9271385 25.3088,20.7617231 L25.3088,20.7617231 Z"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </a>
                                }
                                
                                <a href={this.genEmailLink(event)} className="share share-email">
                                    <svg className="svg img-responsive" width="30" height="30" enableBackground="new 0 0 32 32" version="1.1" viewBox="0 0 32 32">
                                        <title>Share this event via email</title>
                                        <g id="icon-email">
                                            <g>
                                                <path className="circle" d="M16,0C7.163,0,0,7.163,0,16c0,8.836,7.163,16,16,16s16-7.164,16-16C32,7.163,24.837,0,16,0z" fill="#000"/>
                                            </g>
                                            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                                                <g transform="translate(3.000000, 3.000000), scale(0.8)">
                                                    <path fill="#fff" className="logo" d="M25.9230769,21.0769231 L20,16 L25.9230769,10.9230769 L25.9230769,10.9230769 L25.1153846,10.1153846 L16.5,17.5 L7.88461538,10.1153846 L7.07692308,10.9230769 L7.07692308,10.9230769 L13,16 L7.07692308,21.0769231 L7.07692308,21.0769231 L7.88461538,21.8846154 L13.875,16.75 L16.5,19 L19.125,16.75 L25.1153846,21.8846154 L25.9230769,21.0769231 L25.9230769,21.0769231 Z M6.00359486,8 C4.89703997,8 4,8.89451376 4,9.99406028 L4,22.0059397 C4,23.1072288 4.88976324,24 6.00359486,24 L26.9964051,24 C28.10296,24 29,23.1054862 29,22.0059397 L29,9.99406028 C29,8.8927712 28.1102368,8 26.9964051,8 L6.00359486,8 L6.00359486,8 Z" id="mail-envelope-closed"/>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </a>
                            </div>
                        </React.Fragment>
                        :
                            <div className="item-long-description-fullscreen clearfix">
                                <a className="icon icon-close" aria-hidden="true" aria-label="Close" role="button"
                                    onClick={() => { this.setState({ descriptionActive: false }); }}
                                />
                                <h1>{event.name}</h1>
                                <div className="item-long-description">
                                    <Text newlines="display">
                                        {event.description}
                                    </Text>
                                </div>
                                <a className="pull-right btn btn-sm btn-outline btn-black hidden-xl hidden-lg" aria-hidden="true" aria-label="Close"
                                    onClick={() => { this.setState({ descriptionActive: false }); }}
                                >
                                    Close
                                </a>
                            </div>
                    }
                </div>
                
                <EventSchema event={event}/>
            </div>
        );
    }
}
